export const DEFAULT_TIMEOUT_MS = 10_000;

export function isTimeoutError(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'TimeoutError';
}
